import axios from "axios";
import config from "../../config.json";

const authHeaders = () => ({
  Authorization: `Bearer ${localStorage.getItem("tokenLogin")}`,
});

export async function fetchClaimsPerMonthStats(months = 12) {
  const res = await axios.get(`${config.dev}/client-reclamation/stats/by-month`, {
    headers: authHeaders(),
    params: { months },
  });
  return res.data;
}

export async function fetchLostFoundStatusStats(days = 90) {
  const res = await axios.get(`${config.dev}/v2/lost-found/stats/by-status`, {
    headers: authHeaders(),
    params: { days },
  });
  return res.data;
}

export async function fetchMySupportsPriorityStats(days = 90) {
  const res = await axios.get(`${config.dev}/support/stats/by-priority`, {
    headers: authHeaders(),
    params: { days },
  });
  return res.data;
}

export async function fetchReservationsPerEventStats(days = 90, limit = 10) {
  const res = await axios.get(`${config.dev}/events/stats/by-event`, {
    headers: authHeaders(),
    params: { days, limit },
  });
  return res.data;
}

export async function fetchClientInteractionsByMonthStats(months = 12) {
  const res = await axios.get(
    `${config.dev}/v2/clients/stats/interactions-by-month`,
    {
      headers: authHeaders(),
      params: { months },
    }
  );
  return res.data;
}

export async function fetchTableReservationsByMonthStats(months = 12) {
  const res = await axios.get(`${config.dev}/v2/reservations/stats/by-month`, {
    headers: authHeaders(),
    params: { months },
  });
  return res.data;
}

export async function fetchTableReservationsByDayStats(days = 7) {
  const res = await axios.get(`${config.dev}/v2/reservations/stats/by-day`, {
    headers: authHeaders(),
    params: { days },
  });
  return res.data;
}
